import { observer } from "mobx-react-lite";
import { FC } from "react";
import { AuthCardEmailPassword } from "@/components/auth/AuthCardEmailPassword";
import { usePublicAppStore } from "@/store";
import { appRoutes } from "@/app/router";
import { Navigate } from "react-router";
import { AuthLayout } from "@/components/auth/layout/AuthLayout";

export const LogInEmailPasswordPage: FC = observer(() => {
  const { publicStore } = usePublicAppStore();

  if (publicStore.auth.isAuthenticated) {
    return <Navigate to={appRoutes.notesList({}).path} />;
  }

  return (
    <AuthLayout>
      <AuthCardEmailPassword />
    </AuthLayout>
  );
});
